<template>
    <div v-if="questExplore">

        <!-- files -->
        <div class="TQ_padding_8px" v-for="(langCode_e, index_n) in questExplore.qex_langArr_ae" :class="index_n+1 < questExplore.qex_langArr_ae.length ? 'TQ_border_bottom' : ''" >
            <div class="TQ_text_bold TQ_text_28px TQ_padding_4px">
                {{format_langCode_fs(langCode_e)}}
            </div>

            <draggable class="lc_draggable TQ_inline"
                       :move="m_checkMove_f"
                       draggable=".lc_photo"
                       v-model="questExplore.qex_imgsFiles_blc_ac[langCode_e]">

                <div class="lc_photo TQ_center TQ_inline TQ_verticalAlignMiddle"
                     v-for="(imageFile_c,index) in questExplore.qex_imgsFiles_blc_ac[langCode_e]"
                     :key="index">

                    <on-top-container width="auto" class="TQ_margin_4px TQ_bg_white">


                        <tq-img-fill-blur class="TQ_border TQ_box_shadow TQ_inline"
                                          slot="body"
                                          :p_max-width_s="index===0 ? '400px' : '300px'"
                                          :p_height_s="index===0 ? '225px':  '185px'"
                                          :pp_img-url_s="imageFile_c.fi_url_s"/>

                        <div slot="topRight" class="lc_garbage">
                            <img  :src="ass_img_garbage_w"
                                  @click="m_removeImage_f(index, langCode_e)"/>
                        </div>

                    </on-top-container>
                </div>

                <div slot="footer"
                     v-if="questExplore.qex_imgsFiles_blc_ac[langCode_e].length < gv_numbers.maxImageNum_questExplore"
                     class="lc_addImgBtn TQ_inline TQ_border TQ_margin_8px TQ_verticalAlignMiddle TQ_border TQ_box_shadow TQ_bg_white TQ_text_20px TQ_clickable TQ_bg_hover_goldLite"
                     @click="() => {m_chooseFile_f(langCode_e)} ">
                    <img :src="ass_img_image" class="TQ_width_100px">
                    <div> {{ass_strings.twoWords_newImage[langCode_e]}} </div>
                </div>

            </draggable>
        </div>

    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    import {FB_QuestExplore} from "../../../../../functions/src/shareCode/Share_S_Classes";
    import {format_langCode_fs} from "../../../../../functions/src/shareCode/Share_S_Format";
    import OnTopContainer from "../../../../components/basic/TqOnTopContainer";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {ass_img_garbage_w, ass_img_image} from "@/assets/scripts/Ass_Files";
    import {gv_numbers} from "../../../../../functions/src/shareCode/Share_Ass_GlobalVariable";
    import {notification_notify} from "@/scripts/S_Notification";
    import TqImgFillBlur from "@/components/basic2/TqImgFillBlur";
    import {enum_fileType} from "../../../../../functions/src/shareCode/Share_S_Enum";

    export default {
        name: "c_Creator_EditQuests_Item_ExploreGallery",
        components :{
            TqImgFillBlur,
            OnTopContainer,
            draggable,
        },
        props:{
            questExplore:{
                type: FB_QuestExplore,
                require: true
            },
            store_systemLangCode:{
                type: String,
                require: true
            },
            pe_chooseFile_f: {
                type: Function,
                require: true,
            },
        },
        data(){
            return {

                // ass_strings
                ass_strings : ass_strings,
                gv_numbers : gv_numbers,
                ass_img_garbage_w : ass_img_garbage_w,
                ass_img_image : ass_img_image,
                format_langCode_fs : format_langCode_fs
            }
        },
        methods:{
            m_chooseFile_f(langCode_e){
                this.pe_chooseFile_f((file_c) => {

                    switch (file_c.fi_type_e) {
                        case enum_fileType.IMG_svg:
                        case enum_fileType.IMG_png:
                        case enum_fileType.IMG_jpeg:
                        case enum_fileType.IMG_gif:
                            this.questExplore.qex_imgsFiles_blc_ac[langCode_e].push(file_c)
                            break;
                        case enum_fileType.video_mp4:
                        case enum_fileType.audio_mp3:
                        case enum_fileType.audio_mpeg:
                        case enum_fileType.audio_ogg:
                        default :
                            alert("Don't support file format")
                            console.log("Don't support file format", file_c)
                    }
                })


            },
            m_checkMove_f(evt){
                return (evt.draggedContext.element.name!=='addButton');
            },
            m_removeImage_f(index, langCode_e){
                if(this.questExplore.qex_imgsFiles_blc_ac[langCode_e].length === 1){
                    notification_notify(ass_strings.oneWord_error, ass_strings.sentence_errorDeleteLastImage)
                    return
                }
                this.questExplore.qex_imgsFiles_blc_ac[langCode_e].splice(index, 1)
            }
        },


    }
</script>


<style scoped lang="scss">

    .lc_addImgBtn{
        padding: 40px 0;
        width: 300px;
    }

    .lc_draggable {
        text-align: center;

        div.lc_photo {

            &:first-child{
                display: block;
                width: fit-content;
            }

            img {
                margin: 2px;
                border-radius: 2px;
            }

            .lc_garbage{
                margin: 4px;
                img {
                    width: 24px;
                    background-color: #484848;
                    padding: 8px;
                    border-radius: 50%;
                    border: 1px solid white;
                    cursor: pointer;

                    &:hover {
                        border: 1px solid var(--color-gold);
                    }
                }
            }

        }
    }

</style>
